module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OGetuU/tc-custom/9781418573737.jpg?1726574064421",
      "alt": "This image is the cover for the book New York State Trivia"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New York State Trivia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v(" An extensive and entertaining question-and-answer trivia book about the amazing Empire State.")]), _c('br'), _c('br'), _vm._v("Test your New York knowledge with this engaging trivia book. New York State Trivia is filled with exciting questions and answers about the who, what, when, where, and how of the Empire State. You’ll discover countless facts about the history, culture, people, and places of this great state, including:Which Great Lakes border New York StateWhat infamous performer was born in Peekskill on August 27, 1952What town held the first Women’s Rights Convention on July 19, 1848Who co-founded the New York City Ballet in 1948The nation’s oldest horse-racing trackThe state fishAnd more"), _c('br'), _c('br'), _vm._v("With facts ranging from the well-known to the not-so-well-known, New York State Trivia will provide hours of entertainment and education. Sure to delight every native and those just passing through, too!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael J. Mendrick\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0